import {useEffect, useState} from "react";
import {toast} from "react-hot-toast";
import {InventoryService} from "./Service";
import Select from "react-select";
import {UploadService} from "../../utils/UploadService";

const AddCategory = () => {
    const service = new InventoryService();
    const uploadService = new UploadService();
    const [name, setName] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [parent, setParent] = useState<{ label: string, value: string }|null>(null);
    const [parentOptions, setParentOptions] = useState<{ label: string, value: string }[]>([]);
    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (name === '') {
            toast.error('Please fill all the required fields');
            return;
        }
        const res = await service.addCategory({
            name: name,
            parent: parent ? parseInt(parent.value) : undefined,
            image: imageUrl
        });

        if (res) {
            toast.success('Category added successfully');
            setName('');
            setParent(null);
            setImageUrl('');
            getCategories();
        }
    }

    const handleImageChange = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            toast.loading('Uploading image...');
            uploadService.upload(file).then((res) => {
                toast.dismiss();
                if (res.length > 0) {
                    setImageUrl(res[0]);
                    toast.success('Image uploaded successfully');
                }
            });
        }
    };

    const getCategories = async () => {
        const res = await service.allCategories();
        if (res) {
            const options = res.map((item: any) => {
                return {
                    label: item.name,
                    value: item.id
                }
            });
            setParentOptions(options);
        }
    }

    useEffect(() => {
        getCategories();
    }, [])

    return (
        <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>Add Category</h5>
                        </div>
                    </div>
                    <div className="profile-picture">
                        <div className="upload-profile me-2">
                            <div className="profile-img">
                                <img
                                    id="blah"
                                    className="avatar"
                                    src={imageUrl !== '' ? imageUrl : `https://ui-avatars.com/api/?background=4F6F52&color=fff&name=${name.length > 0 ? name : 'Category'}&size=40&rounded=true`}
                                    alt="profile-img"
                                />
                            </div>
                        </div>
                        <div className="img-upload">
                            <label className="btn btn-primary">
                                Upload new image <input type="file"
                                                                  onChange={handleImageChange}/>
                            </label>
                            <p className="mt-1">
                                Image Should be minimum 152 * 152 Supported File format JPG,PNG.
                            </p>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit} className="row">
                        <div className="col-lg-12">
                            <div className="form-title">
                                <h5>General Information</h5>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="input-block mb-3">
                                <label>Name <span className="text-danger">(required)</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter user name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>

                        <div className="col-12 mb-5">
                            <label htmlFor="type" className="form-label">Parent Category</label>
                            <Select
                                name="permission"
                                options={parentOptions}
                                value={parent}
                                onChange={setParent}/>
                        </div>
                        <div className="col-12">
                            <div className="btn-path text-end">
                                <a
                                    href="javascript:void(0);"
                                    className="btn btn-cancel bg-primary-light me-3"
                                    onClick={() => {
                                        window.history.back();
                                    }}
                                >
                                    Cancel
                                </a>
                                <button type="submit" className="btn btn-primary">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default AddCategory;